import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { ButtonSize, ButtonVariant } from '@/components/button';
import IconButton from '@/components/button/iconButton';

type Props = PropsWithChildren & {
  className?: string;
  iconClassName?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  icon?: IconProp;
};

export const CardIconButton: FC<Props> = ({
  icon = undefined,
  className = '',
  onClick = undefined,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
  iconClassName = '',
  children = undefined,
}) => {
  if (!icon && !children) return null;

  return (
    <IconButton
      className={twMerge(
        'flex h-8 w-8 items-center justify-center rounded-sm bg-white p-1.5 text-gray-70 hover:bg-gray-10',
        className
      )}
      size={ButtonSize.MEDIUM}
      variant={ButtonVariant.GHOST}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children ||
        (icon && (
          <FontAwesomeIcon
            className={twMerge('min-h-[16px] min-w-[16px]', iconClassName)}
            icon={icon}
          />
        ))}
    </IconButton>
  );
};
